import { useSelector } from 'react-redux';
import type { ProcessScrollItem } from '../../../../common/enums/processScrollItem';
import type { ServiceCode } from '../../../../common/enums/serviceCode';
import type { IReduxState } from '../../../configureStore';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import type { IItemState } from '../../pages/episodes/Episode';
import type { ReloadEpisode } from '../../pages/episodes/reloadEpisode';
import { ButtonContainer } from '../common';
import { ArchiveReferralButton } from './ArchiveReferralButton';
import { CancelProcessButton } from './CancelProcessButton';
import { ConfirmReferralSmallRequestButton } from './ConfirmReferralSmallRequestButton';
import { EditRequestButton } from './EditRequestButton';
import { PrintPdfButton } from './PrintPdfButton';
import { RejectReferralButton } from './RejectReferralButton';
import { ResendReferralButton } from './ResendReferralButton';

interface IReferralReadButtonProps {
    editRequest: () => Promise<void>;
    isLastItem: boolean;
    reloadProcess: (mode?: ReloadEpisode) => Promise<void>;
    removeProcess: () => Promise<void>;
    request: IRequestGetOne;
    serviceCode: ServiceCode;
    updateProcessItemStateByRequestId?: (
        requestId: string,
        itemState: IItemState,
        scrollItem: ProcessScrollItem
    ) => Promise<void>;
}

export function ReferralSmallReadButtons(props: IReferralReadButtonProps) {
    const isManager = useSelector((state: IReduxState) => state.authentication.isManager);

    if (isManager) {
        return null;
    }

    if (!props.isLastItem) {
        return (
            <ButtonContainer
                alignRight
                buttons={[<PrintPdfButton request={props.request} />]}
            />
        );
    }

    return (
        <ButtonContainer
            alignRight
            buttons={[
                <PrintPdfButton request={props.request} />,
                <CancelProcessButton
                    cancelProcess={props.removeProcess}
                    reloadProcess={props.reloadProcess}
                    request={props.request}
                    serviceCode={props.serviceCode}
                />,
                <EditRequestButton
                    editRequest={props.editRequest}
                    request={props.request}
                />,
                <ArchiveReferralButton
                    reloadProcess={props.reloadProcess}
                    request={props.request}
                />,
                <ResendReferralButton
                    reloadProcess={props.reloadProcess}
                    request={props.request}
                    updateProcessItemStateByRequestId={props.updateProcessItemStateByRequestId}
                />,
                <RejectReferralButton
                    reloadProcess={props.reloadProcess}
                    request={props.request}
                />,
                <ConfirmReferralSmallRequestButton
                    reloadProcess={props.reloadProcess}
                    request={props.request}
                    serviceCode={props.serviceCode}
                />,
            ]}
        />
    );
}
